import { useSelector } from "react-redux";
import MainSelect from "../../main-select/main-select";
import FileAdd from "./add-file";
import { SelectOption } from "../../../utils/select-options";
import { transformData } from "../../../utils/transform-data";
import Image from "../../uploads/image/image";

import styles from "../../../pages/use-trademark/styles.module.scss";

const Form = ({ control, watch }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL_IMG;

  const { list } = useSelector((state) => state.city);
  const { image } = useSelector((state) => state.image);
  const { trademarkObjectionList } = useSelector((state) => state.operations);
  const currentObjectionTrademark = watch("tm_or_ob");

  const currentObjectionTrademarkImg = trademarkObjectionList.find(
    (item) => item.id === currentObjectionTrademark
  );

  const optionsCity = SelectOption(list);
  const trademarksObjectionOptions = transformData(
    trademarkObjectionList,
    true
  );

  return (
    <>
      <MainSelect
        name="tm_or_ob"
        isFormatOptions
        control={control}
        options={trademarksObjectionOptions}
        placeholder="Ապրանքանիշ / Առարկություն"
        className={styles.ues_trademark_select}
      />
      {currentObjectionTrademarkImg?.image && (
        <img
          width={130}
          height={190}
          alt={currentObjectionTrademarkImg?.name}
          src={BASE_URL + currentObjectionTrademarkImg?.image}
          className={styles.use_trademark_img}
        />
      )}
      <br />
      <MainSelect
        name="country"
        control={control}
        placeholder="Երկիր"
        options={optionsCity}
        className={styles.ues_trademark_select}
      />
      <br />
      <Image
        name="image"
        image={image}
        control={control}
        allowVideo={true}
        className={styles.image}
        title="Ավելացնել լուսանկար/տեսանյութ"
      />
      <FileAdd control={control} name="upload_file" url="use-trade-mark" />
    </>
  );
};

export default Form;
